var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "20px", height: "95%" },
          attrs: {
            title: _vm.title,
            width: 1300,
            visible: _vm.visible,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            wrapClassName: _vm.wrapClassNameInfo(),
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "关闭",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _vm.selectType === "list"
            ? _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "单据编号",
                                    labelCol: { span: 5 },
                                    wrapperCol: { span: 18, offset: 1 },
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "请输入单据编号查询",
                                    },
                                    model: {
                                      value: _vm.queryParam.number,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "number", $$v)
                                      },
                                      expression: "queryParam.number",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "商品信息",
                                    labelCol: { span: 5 },
                                    wrapperCol: { span: 18, offset: 1 },
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "条码|名称|规格|型号",
                                    },
                                    model: {
                                      value: _vm.queryParam.materialParam,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "materialParam",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.materialParam",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "单据日期",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-range-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      format: "YYYY-MM-DD",
                                      placeholder: ["开始时间", "结束时间"],
                                    },
                                    on: {
                                      change: _vm.onDateChange,
                                      ok: _vm.onDateOk,
                                    },
                                    model: {
                                      value: _vm.queryParam.createTimeRange,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "createTimeRange",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.createTimeRange",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              staticStyle: {
                                float: "left",
                                overflow: "hidden",
                              },
                            },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 6, sm: 24 } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.searchQuery },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.searchReset },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.selectType === "list"
            ? _c("a-table", {
                ref: "table",
                attrs: {
                  bordered: "",
                  size: "middle",
                  rowKey: "id",
                  columns: _vm.columns,
                  dataSource: _vm.dataSource,
                  components: _vm.handleDrag(_vm.columns),
                  pagination: _vm.ipagination,
                  loading: _vm.loading,
                  rowSelection: {
                    selectedRowKeys: _vm.selectedRowKeys,
                    onChange: _vm.onSelectChange,
                    type: _vm.getType,
                  },
                  customRow: _vm.rowAction,
                },
                on: { change: _vm.handleTableChange },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "numberCustomRender",
                      fn: function (text, record) {
                        return _c("span", {}, [
                          !_vm.queryParam.purchaseStatus
                            ? _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.myHandleDetail(record)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(record.number))]
                              )
                            : _vm._e(),
                          _vm.queryParam.purchaseStatus
                            ? _c("span", [_vm._v(_vm._s(record.number))])
                            : _vm._e(),
                        ])
                      },
                    },
                    {
                      key: "customRenderStatus",
                      fn: function (text, record) {
                        return [
                          [
                            record.status === "1"
                              ? _c("a-tag", { attrs: { color: "green" } }, [
                                  _vm._v("已审核"),
                                ])
                              : _vm._e(),
                            record.status === "3" &&
                            _vm.queryParam.type === "入库"
                              ? _c("a-tag", { attrs: { color: "blue" } }, [
                                  _vm._v("部分入库"),
                                ])
                              : _vm._e(),
                            record.status === "3" &&
                            _vm.queryParam.type === "出库"
                              ? _c("a-tag", { attrs: { color: "blue" } }, [
                                  _vm._v("部分出库"),
                                ])
                              : _vm._e(),
                          ],
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3231973004
                ),
              })
            : _vm._e(),
          _vm.selectType === "detail"
            ? _c("a-table", {
                ref: "table",
                attrs: {
                  bordered: "",
                  size: "middle",
                  rowKey: "id",
                  pagination: false,
                  columns: _vm.columnsDetail,
                  dataSource: _vm.dataSourceDetail,
                  components: _vm.handleDrag(_vm.columnsDetail),
                  loading: _vm.loading,
                  rowSelection: {
                    selectedRowKeys: _vm.selectedDetailRowKeys,
                    onChange: _vm.onSelectDetailChange,
                    type: "checkbox",
                  },
                },
                on: { change: _vm.handleTableChange },
              })
            : _vm._e(),
          _c("bill-detail", { ref: "billDetail" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }